import SeriesIndexPage from "@/Pages/Series/index.vue";
import NewEditSeriePage from "@/Pages/Series/NewEditSeriePage.vue";
import { can } from "@/plugins/can";

const checkPermission = (permissions) => {
  return (to, from, next) => {
    if (!can(permissions)) {
      return next({ name: "NaoAutorizado" });
    }
    return next();
  };
};

export default [
  {
    path: "/series/",
    name: "series",
    component: SeriesIndexPage,
    beforeEnter: checkPermission(["series.*", "series.criar"]),
  },
  {
    path: "/series/create",
    name: "series.create",
    component: NewEditSeriePage,
    props: { editing: false },
  },
  {
    path: "/series/edit/:serie_id",
    name: "series.edit",
    component: NewEditSeriePage,
    props: { editing: true },
  },
];
